<template>
  <div>
    <form @submit.prevent="triggerSaveComment()" v-if="!isCommentSaveTriggered">
      <div class="sd-comment-img-container" v-if="commentImage || commentImageURL">
        <img v-if="commentImage" :src="generateImageSrc()" class="img-fluid sd-comment-img">
        <img v-else-if="commentImageURL" :src="commentImageURL" class="img-fluid sd-comment-img">
        <div class="sd-comment-overlay">
          <div class="row no-gutters sd-comment-overlay-text">
            <div class="col-8">
              <div v-if="isChainageEnabled" class="pl-2 sd-font-xs text-white text-capitalize">Chainage: {{commentChainage}}</div>
              <div v-else-if="commentSeconds" class="pl-2 sd-font-xs text-white text-capitalize">Video time : {{timeInMin(commentSeconds)}}</div>
              <div v-else class="pl-2 sd-font-xs text-white text-capitalize">Co-ordinates:({{parseFloat(latlng.lat, 10).toFixed(3)}}, {{parseFloat(latlng.lng, 10).toFixed(3)}})</div>
            </div>
            <div class="col-4 text-right">
              <a @click="enableViewer"
                class="sd-font-xs text-white pr-2 sd-cursor-pointer">
                <img src="@/assets/img/open_project.svg" width="15" class="pr-1">Zoom
              </a>
            </div>
          </div>
        </div>
      </div>
      <textarea
        rows="2"
        class="form-control form-control-sm mt-1"
        name="commenttext" placeholder="Enter comment here"
        v-model="commentText"
        id="commenttext"> </textarea>
        <div class="row no-gutters pt-1">
          <div class="col-6 pr-2">
            <select
              class="form-control form-control-sm sd-font-xs p-0 border-0"
              v-model="commentPriority">
              <option value="null">Select Priority</option>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>
          <div class="col-6">
            <select class="form-control form-control-sm sd-font-xs p-0 border-0" v-model="commentCategory">
              <option value="null">Select Category</option>
              <option v-for="category in commentCategories" :key="category.id" :value="category.id">
                {{category.category}}
              </option>
            </select>
          </div>
        </div>
        <div class="sd-font-xs text-primary" v-if="commentError">{{commentError}}</div>
      <button type="submit" class="ml-0 btn btn-primary btn-sm w-100">Create</button>
    </form>
    <div v-if="isCommentSaveTriggered && !isCommentCreated">
      <p>Creating Issue...</p>
    </div>
    <div v-if="isCommentCreated">
      <p>Issue successfully created</p>
    </div>

      <!-- Zoom Viewer -->
      <div style='display: none'>
        <div ref='zoomViewer'>
          <img v-if="commentImage" :src="generateImageSrc()">
          <img v-else-if="commentImageURL" :src="commentImageURL">
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import api from '@/api';
import { generateHashFromString } from '@/utils/otherUtils';
import Viewer from 'viewerjs';

export default {
  props: ['commentPopupHandler', 'subsectionDataId', 'latlng', 'commentImage', 'commentSeconds', 'videoTime', 'commentImageURL', 'polygonCoordinates', 'isChainageEnabled', 'commentChainage'],
  data() {
    return {
      commentCategory: 'null',
      commentPriority: 'null',
      commentText: '',
      isCommentSaveTriggered: false,
      isCommentCreated: false,
      viewer: '',
      zoomedFrame: '',
      commentError: '',
    };
  },
  mounted() {
    this.viewer = new Viewer(this.$refs.zoomViewer);
  },
  computed: {
    ...mapState([
      'auth',
      'commentCategories',
    ]),
  },
  methods: {
    ...mapActions([
      'retrieveComments',
    ]),
    triggerSaveComment() {
      if(this.commentText=='') {
        this.commentError = "Please enter comment text";
        return;
      } else if(this.commentPriority == "null") {
        this.commentError = "Please select priority";
        return;
      } else if(this.commentCategory == "null") {
        this.commentError = "Please select category";
        return;
      }
      this.commentError = '';
      this.isCommentSaveTriggered = true;
      this.isCommentCreated = false;
      let formData = new FormData();
      let imageBlob = '';
      let imageName = '';

      // console.log('subsectionId',this.subsectionDataId);
      formData.append("subsection_data", this.subsectionDataId);      
      formData.append("text", this.commentText);
      formData.append("video_time", this.videoTime);
      formData.append("latitude", this.latlng.lat);
      formData.append("longitude", this.latlng.lng);
      formData.append("priority", this.commentPriority);
      formData.append("category", this.commentCategory);
      if(this.polygonCoordinates) {

        this.polygonCoordinates.forEach((coords, index)=>{
          let arr = [coords.lat, coords.lng];
          formData.append(`coordinates[${index}][0]`, coords.lat);
          formData.append(`coordinates[${index}][1]`, coords.lng);
        });
        // Leaflet Draw doesn't provide last lat lng, so use first as last.
        formData.append(`coordinates[${this.polygonCoordinates.length}][0]`, this.polygonCoordinates[0].lat);
        formData.append(`coordinates[${this.polygonCoordinates.length}][1]`, this.polygonCoordinates[0].lng);
      }
      
      // Since We have a JS async call to get image blob we are calling saveComment after async is complete.
      // TODO: Use async,await instead. 
      if(this.commentImage) {
        imageBlob = this.commentImage;
        imageName = Math.abs(generateHashFromString(this.generateImageSrc()));
        formData.append("image", imageBlob, imageName+'.png');
        
        api.saveComment(formData).then((response) => {          
          if (response.status === 201) {
            this.isCommentCreated = true;
            this.retrieveComments(this.subsectionDataId);
            this.$emit('commentCreateSuccess');
          }
        }).catch((e)=>{
          // Handle Error
        });
      } else if (this.commentImageURL) {
          // Server expects image to be a blob. so get image blob using image URL.
          axios.get(this.commentImageURL, {responseType:"blob"}).then((response) => {
              if(response.status === 200) {
                imageBlob = response.data;
                imageName = Math.abs(generateHashFromString(this.commentImageURL));
                formData.append("image", imageBlob, imageName+'.png');

                api.saveComment(formData).then((response) => {
                  if (response.status === 201) {
                    this.isCommentCreated = true;
                    this.retrieveComments(this.subsectionDataId);
                    this.$emit('commentCreateSuccess');
                  }
                }).catch((e)=>{
                  // Handle Error
                });
              }
            });
      } 
    },
    generateImageSrc() {
      if(this.commentImage) {
        // console.log(this.commentImage);
        let imageObject = [];
        imageObject.push(this.commentImage);
        const imageSrc = window.URL.createObjectURL(new Blob(imageObject, {type: "application/zip"}));
        return imageSrc;
      }
      return 'null';
    },
    enableViewer() {
      this.viewer.show();
    },
    timeInMin(s) {
      let sec = Math.floor(s);
      let mins = Math.floor(sec/60);
      let secs = sec % 60;
      return mins+':'+secs;
    }
  },
}
</script>

<style lang="scss" scoped>

// Work Around: this is to overwrite '.videojs button' class 
.btn-primary {
  color: #fff !important;
  background-color: #f06031 !important;
  border-color: #f06031 !important;
}
</style>


